import { render, staticRenderFns } from "./registernew.vue?vue&type=template&id=4c77f9b4&scoped=true"
import script from "./registernew.vue?vue&type=script&setup=true&lang=js"
export * from "./registernew.vue?vue&type=script&setup=true&lang=js"
import style0 from "./registernew.vue?vue&type=style&index=0&id=4c77f9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77f9b4",
  null
  
)

export default component.exports